import { createAppKit } from '@reown/appkit/vue';
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { baseSepolia, base, type AppKitNetwork } from '@reown/appkit/networks';
import { http, createStorage, cookieStorage } from '@wagmi/core';
import { injected } from 'wagmi/connectors';
import { CreateConnectorFn } from 'wagmi';
import { createClient } from 'viem';
import { ENV } from '../../../../../utils/useConfig';

const projectId = ENV.project_id;
const defaultNetwork = ENV.env === 'production' ? base : baseSepolia;

const storage = createStorage({
  storage: cookieStorage,
});

export const connectors: CreateConnectorFn[] = [];
connectors.push(injected({ shimDisconnect: true }));

export const networks: [AppKitNetwork, ...AppKitNetwork[]] = [base, baseSepolia];

export const chainId = defaultNetwork.id;

export const wagmiAdapter = new WagmiAdapter({
  storage,
  connectors,
  projectId,
  networks,
  client({ chain: defaultNetwork }) {
    return createClient({ chain: defaultNetwork, transport: http() })
  },
});

export const walletConfig = wagmiAdapter.wagmiConfig;

export const walletModal = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  projectId,
  metadata: ENV.metadata,
  defaultNetwork,
  featuredWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa',
  ],
  includeWalletIds: [
    'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96',
    'fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa',
  ],
  allWallets: 'ONLY_MOBILE',
  features: {
    email: false,
    socials: false,
    analytics: true,
  },
  enableWalletConnect: false,
  coinbasePreference: 'eoaOnly',
});
